import {
    OPERATOR_TERMS_AND_POLICIES_START,
    OPERATOR_TERMS_AND_POLICIES_SUCCESS,
    OPERATOR_TERMS_AND_POLICIES_ERROR,
    OPERATOR_TERMS_AND_POLICIES_SAVE_START,
    OPERATOR_TERMS_AND_POLICIES_SAVE_SUCCESS,
    OPERATOR_TERMS_AND_POLICIES_SAVE_ERROR,
  } from "Constant";
  
  const initialState = {
    loading: false,
    data: [],
  };
  
  export default function TermsAndPoliciesReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case OPERATOR_TERMS_AND_POLICIES_START:
        return {
          ...state,
          loading: true,
        };
      case OPERATOR_TERMS_AND_POLICIES_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case OPERATOR_TERMS_AND_POLICIES_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
        case OPERATOR_TERMS_AND_POLICIES_SAVE_START:
          return {
            ...state,
            loading: true,
          };
        case OPERATOR_TERMS_AND_POLICIES_SAVE_SUCCESS:
          return {
            ...state,
            data: action.payload,
            loading: false,
          };
        case OPERATOR_TERMS_AND_POLICIES_SAVE_ERROR:
          return {
            ...state,
            loading: false,
            message: action.error.message,
          };
      default:
        return state;
    }
  }
  